import { Boxes } from "lucide-react";
import { Badge } from "../../../ui/common-ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/common-ui/card";
import { GraphNode } from "../types/graph";
import { ResourceGroupList, type GroupedResource } from "./ResourceGroupList";

interface ResourceGroupInspectorProps {
  node: GraphNode;
}

export function ResourceGroupInspector({ node }: ResourceGroupInspectorProps) {
  const props = node.props || {};
  const resources = (props.resources || []) as GroupedResource[];

  return (
    <Card className="border-border/50 bg-card shadow-lg">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <div className="p-1.5 rounded-lg bg-teal-500/10">
            <Boxes className="w-4 h-4 text-teal-500" />
          </div>
          Not Shown On Graph
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <p className="text-sm font-semibold text-foreground">{node.label}</p>
          {props.parentRole && (
            <p className="mt-1 text-xs text-muted-foreground">
              Accessed through {String(props.parentRole).split("/").pop()}
            </p>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          {props.resourceType && <Badge variant="outline" className="text-[10px]">{String(props.resourceType)}</Badge>}
          {typeof props.resourceCount === "number" && (
            <Badge variant="secondary" className="text-[10px]">{props.resourceCount} total</Badge>
          )}
        </div>
        {resources.length > 0 ? (
          <ResourceGroupList resources={resources} />
        ) : (
          <p className="text-xs text-muted-foreground">No resource detail was captured for this group.</p>
        )}
      </CardContent>
    </Card>
  );
}
